import * as React from 'react'
import { Helmet } from 'react-helmet'

import NewBrandDashboard from '../BrandDashboard'

import SubBrands from './SubBrands/SubBrands'

interface BrandDashboardSubBrandsProps {
  match?: { params: { id: string } }
  searchToken?: string
}

const BrandDashboardSubBrands: React.FC<BrandDashboardSubBrandsProps> = ({
  match,
  searchToken,
}) => {
  const brandId = (match && match.params.id) || ''

  return (
    <>
      <Helmet>
        <title>Sub brands - 90 Seconds</title>
      </Helmet>
      <NewBrandDashboard
        brandId={brandId}
        children={<SubBrands />}
        activeButton={7}
        subHeaderTitle="Enterprise"
        searchToken={searchToken}
      />
    </>
  )
}

export default BrandDashboardSubBrands



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSubBrands/BrandDashboardSubBrands.tsx